import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, timeout } from 'rxjs/operators';
import { AuthService } from './auth.service';
import { AuthResponseModel } from '../Models/Authentication/AuthResponse';
import { ModelService } from './model.service';

@Injectable({
  providedIn: 'root'
})
export class BaseApiService {
  constructor(private http: HttpClient, private messageService: ModelService, private auth:AuthService) {}
  authResponse!            :AuthResponseModel;
  create(url: string, data: any): Observable<any> {
    return this.http.post<any>(url, data).pipe(
      timeout(600000),
      catchError((error: HttpErrorResponse) => this.handleError(error))
    );
  }

  read(url: string): Observable<any> {
    return this.http.get<any>(url).pipe(
      timeout(600000),
      catchError((error: HttpErrorResponse) => this.handleError(error))
    );
  }

  update(url: string, data: any): Observable<any> {
    return this.http.put<any>(url, data).pipe(
      timeout(600000),
      catchError((error: HttpErrorResponse) => this.handleError(error))
    );
  }

  delete(url: string): Observable<any> {
    return this.http.delete<any>(url).pipe(
      timeout(600000),
      catchError((error: HttpErrorResponse) => this.handleError(error))
    );
  }

  getLang(lan: string): string {
   return "en";
  }

  private handleError(error: HttpErrorResponse): Observable<never> {
    
    let message: string = 'Error' +" ";
    if (error.error && error.error) {
        message += error.error;
    }
    
    else if (error.error && error.error.message) {
      message += error.error.message;
      
    } else if (error.error && error.error.title) {
      message += error.error.title;
    } else if (error.error && error.error.errors) {
      const firstErrorField = Object.keys(error.error.errors)[0];
      const firstErrorMessage = error.error.errors[firstErrorField][0];
      if (firstErrorMessage) {
        message += ': ' + firstErrorMessage;
      }
    }

    this.messageService.showErrorAlert(error.error.message);
    return throwError(message);


    
  }

  RefreshToken()
  {   
    const email=this.auth.getLoggedEmail()
    this.read(`Auth/TokenRefresh?loginDto=${email}`).subscribe
      (
           (response)=>
           {
            this.authResponse   =response;
            if (this.authResponse.token!==null)
            {
              this.auth.saveToken(this.authResponse.token);
              window.location.replace("/ManueDash")
            } else 
            {
              this.auth.logout();
            }
           },
           (
             error
           )=>
           {
              this.messageService.showErrorAlert(error.error.message);
           }
      )
  } 
  DeletMyAccount()
  {   
    const email=this.auth.getLoggedEmail()
    this.read(`Auth/DeletmyAccount?loginDto=${email}`).subscribe
      (
           (response)=>
           {
            this.authResponse   =response;
            this.auth.logout();
            window.location.replace("/login")
           },
           (
             error
           )=>
           {
            this.messageService.showErrorAlert(error.error.message);
           }
      )
  } 
  // Define a map of news providers with their respective full names and logo URLs.
  newsProviders = new Map<string, { fullName: string; logoUrl: string }>([
  ["https://www.france24.com/fr/business-tech/rss", { fullName: "France 24", logoUrl: "../../assets/images/newsLogos/france24.jpg" }],
  ["https://www.lemonde.fr/economie/rss_full.xml", { fullName: "Le Monde", logoUrl: "../../assets/images/newsLogos/lemond.png" }],
  ["https://www.lesechos.fr/rss", { fullName: "Les Echos", logoUrl: "../../assets/images/newsLogos/lesecho.jpg" }],
  ["https://www.lefigaro.fr/rss/figaro_economie.xml", { fullName: "Le Figaro", logoUrl: "../../assets/images/newsLogos/Le-Figaro-1.jpg" }],
  ["https://www.liberation.fr/arc/outboundfeeds/rss-all/category/economie/?outputType=xml", { fullName: "Libération", logoUrl: "../../assets/images/newsLogos/libr.jpg" }],
  ["https://www.bfmtv.com/rss/immobilier/", { fullName: "BFM TV - Immobilier", logoUrl: "../../assets/images/newsLogos/BFMTV.jpg" }],
  ["https://www.bfmtv.com/rss/economie/patrimoine", { fullName: "BFM Économie - Patrimoine", logoUrl: "../../assets/images/newsLogos/BFMTV.jpg" }],
  ["https://www.tradingsat.com/rssbourse.xml", { fullName: "BFM BOURSE", logoUrl: "../../assets/images/newsLogos/bfmborse.jpg" }],
  ["https://www.bfmtv.com/rss/economie/economie-social", { fullName: "BFM Économie - Économie Sociale", logoUrl: "../../assets/images/newsLogos/BFMTV.jpg" }],
  ["https://www.bfmtv.com/rss/economie/international", { fullName: "BFM Économie - International", logoUrl: "../../assets/images/newsLogos/BFMTV.jpg" }],
  ["https://www.bfmtv.com/rss/economie/entreprises", { fullName: "BFM Économie - Entreprises", logoUrl: "../../assets/images/newsLogos/BFMTV.jpg" }],
  ["https://www.bfmtv.com/rss/economie/consommation", { fullName: "BFM Économie - Consommation", logoUrl: "../../assets/images/newsLogos/BFMTV.jpg" }],
  ["https://www.bfmtv.com/rss/economie/emploi", { fullName: "BFM Économie - Emploi", logoUrl: "../../assets/images/newsLogos/BFMTV.jpg" }],
  ["https://www.bfmtv.com/rss/economie/entreprises/industries", { fullName: "BFM Économie - Industries", logoUrl: "../../assets/images/newsLogos/BFMTV.jpg" }],
  ["https://www.bfmtv.com/rss/economie/entreprises/services", { fullName: "BFM Économie - Services", logoUrl: "../../assets/images/newsLogos/BFMTV.jpg" }],
  ["https://www.bfmtv.com/rss/economie/entreprises/transports", { fullName: "BFM Économie - Transports", logoUrl: "../../assets/images/newsLogos/BFMTV.jpg" }],
  ["https://www.bfmtv.com/rss/economie/entreprises/assurance-banque", { fullName: "BFM Économie - Assurance et Banque", logoUrl: "../../assets/images/newsLogos/BFMTV.jpg" }],
  ["https://www.bfmtv.com/rss/economie/entreprises/aeronautique", { fullName: "BFM Économie - Aéronautique", logoUrl: "../../assets/images/newsLogos/BFMTV.jpg" }],
  ["https://www.bfmtv.com/rss/economie/entreprises/energie", { fullName: "BFM Économie - Énergie", logoUrl: "../../assets/images/newsLogos/BFMTV.jpg" }],
  ["https://www.bfmtv.com/rss/economie/entreprises/culture-loisirs", { fullName: "BFM Économie - Culture et Loisirs", logoUrl: "../../assets/images/newsLogos/BFMTV.jpg" }],
  ["https://www.bfmtv.com/rss/economie/experts", { fullName: "BFM Économie - Experts", logoUrl: "../../assets/images/newsLogos/BFMTV.jpg" }],
  ["https://www.bfmtv.com/rss/economie/patrimoine/immobilier", { fullName: "BFM Économie - Immobilier", logoUrl: "../../assets/images/newsLogos/BFMTV.jpg" }],
  ["https://www.bfmtv.com/rss/economie/patrimoine/retraite", { fullName: "BFM Économie - Retraite", logoUrl: "../../assets/images/newsLogos/BFMTV.jpg" }],
  ["https://www.bfmtv.com/rss/economie/patrimoine/placements-epargne", { fullName: "BFM Économie - Placements et Épargne", logoUrl: "../../assets/images/newsLogos/BFMTV.jpg" }],
  ["https://www.bfmtv.com/rss/economie/patrimoine/impots-fiscalite", { fullName: "BFM Économie - Impôts et Fiscalité", logoUrl: "../../assets/images/newsLogos/BFMTV.jpg" }],
  ["https://www.bfmtv.com/rss/economie/patrimoine/succession", { fullName: "BFM Économie - Succession", logoUrl: "../../assets/images/newsLogos/BFMTV.jpg" }],
  ["https://www.challenges.fr/entreprise/rss.xml", { fullName: "Challenges", logoUrl: "../../assets/images/newsLogos/challenges.jpg" }],
  ["https://www.bfmtv.com/rss/economie", { fullName: "BFM Économie", logoUrl: "../../assets/images/newsLogos/BFMTV.jpg" }],
  ["https://www.bfmtv.com/rss/crypto", { fullName: "BFM Crypto", logoUrl: "../../assets/images/newsLogos/BFMTV.jpg" }]
]);


  getNewsProviderDetails(keyword: string): { fullName: string; logoUrl: string } | undefined {
    // Convert the keyword to lowercase for case-insensitive comparison
    const lowerKeyword = keyword.toLowerCase();

    for (const [key, details] of this.newsProviders) {
        // Check if the lowercase keyword is included in the lowercase key
        if (key.toLowerCase().includes(lowerKeyword)) {
            return details; // Return the associated details if a match is found
        }
    }
    return undefined; // Return undefined if no match is found
}

}
